(ns scittle.instaparse
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [instaparse.core]
    [instaparse.transform]))

;; Plugin: instaparse
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::instaparse
   {:namespaces
   {'instaparse.core (sci/copy-ns instaparse.core (sci/create-ns 'instaparse.core nil))
    'instaparse.transform (sci/copy-ns instaparse.transform (sci/create-ns 'instaparse.transform nil))}}
   ))
